export class StringUtil {
    static isSuccess(response: string) {
        return response === "00"
    }

    static handleCurrencyFormatter = (amount: string) => {
        amount = amount.toString()
        amount = this?.formatAmount(amount);
        amount = isNaN(parseFloat(amount)) ? "" : amount;
        return amount;
    };

    static isStringNullOrEmpty = (string: string | null) => {
        if (string == null) {
            return true;
        }
        return string == "";

    };

    static unformatPhoneNumber = (phoneNumber: string) => {
        return "0" + phoneNumber.slice(-10);
    }

    static toTitleCase(sentence: string) {
        // Split the input string into sentences
        const words = sentence?.split(" ");

        // Capitalize the first letter of each sentence
        const titleCase = words?.map((word) => {
            // Capitalize the first letter of the sentence
            const firstLetter = word.charAt(0).toUpperCase();
            // Concatenate the capitalized first letter with the rest of the word
            return firstLetter + word.slice(1).toLowerCase();
        });
        // Join the sentences back together with a period and space
        const result = titleCase.join(" ");
        // console.log(result);
        return result;
    }

    static convertToSentenceCase(input: string): string {
        input = String(input)
        // Check if the input is in camelCase or snake_case format
        const isCamelCase = /[a-z][A-Z]/.test(input);
        const isSnakeCase = /_/.test(input);

        if (!isCamelCase && !isSnakeCase) {
            return this.toTitleCase(input); // Return the original string if it isn't camelCase or snake_case
        }

        let result = input;

        // Convert snake_case to spaces
        if (isSnakeCase) {
            result = result.replace(/_/g, ' ');
        }

        // Convert camelCase to spaces
        if (isCamelCase) {
            result = result.replace(/([a-z])([A-Z])/g, '$1 $2');
        }

        // Capitalize the first letter of the sentence
        result = result.replace(/^./, str => str.toUpperCase());

        return this.toTitleCase(result);
    }


    static formatAmount = (amount: string): string => {
        // Remove commas and convert to number for easier manipulation
        // let numericAmount = parseFloat(amount);
        const numericAmount = parseFloat(amount?.replace(',', ""));
        if (amount?.endsWith(".")) return numericAmount?.toLocaleString("en-US") + ".";
        if (amount?.includes(".") && this?.countOccurrences(amount, ".") == 1) {
            const [amountInt, amountDecimal] = amount?.split(".");
            const formattedAmountInt = this?.formatAmount(amountInt);
            return formattedAmountInt + "." + amountDecimal;
        }
        if (amount?.includes(".")) {
            return amount;
            // Format with commas
        }
        // Format with commas
        return numericAmount?.toLocaleString("en-US");
    };

    static formatCurrency(amount: string, currency: string = "NGN"): string {
        const currencyOptions: Intl.NumberFormatOptions = {
            style: "currency",
            currency: currency, // Replace with your desired currency code (e.g., 'EUR', 'GBP')
            minimumFractionDigits: 2, // Minimum number of decimal places
        };
        const currencyFormatter = new Intl.NumberFormat("en-US", currencyOptions); // Replace 'en-US' with the appropriate locale
        return currencyFormatter.format(Number(amount)).replace("NGN", "₦").trim();
    }

    static countOccurrences(mainStr: string, subStr: string) {
        // Initialize count
        let count = 0;

        // Loop through the string to find occurrences
        let index = mainStr.indexOf(subStr);
        while (index !== -1) {
            // If substring is found, increase count and move to the next index
            count++;
            index = mainStr.indexOf(subStr, index + 1);
        }

        return count;
    }

    // typeof item[it.key] === 'string' ? (item[it.key].length > 15 ? item[it.key].slice(0, 15) + '...' : item[it.key]) : String(item[it.key])
    static shortenText = (text: any) => {
        const newText = String(text)
        return newText.length > 15 ? newText.slice(0, 15) + "..." : newText
    }

    static generateRandomString = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        let result = '';

        for (let i = 0; i < 20; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters.charAt(randomIndex);
        }

        // setRandomString(result);
        return result
    };
}
